
import * as framework from '../../../framework/export';
import { PjBaseReq } from './PjBaseReq';

/**
 * プロジェクト向け基盤Service
 */
export class PjBaseService extends framework.BaseService {
    /**
     * @constructor
     * @param {ng.IHttpService} $http - http
     */
    constructor(protected $http: ng.IHttpService) {
        super($http);
    }

    /**
     * サーバからデータを取得する（検索およびデータ取得に使用）
     * @param {string} url リクエスト先URL
     * @param {pjfw.PjBaseReq} params - リクエストパラメータ
     * @param {boolean} unique - 2重送信の抑止の設定(true：抑止, false：抑止しない）
     * @return {ng.IHttpPromise} 実行結果のプロミス
     */
    protected get(url: string, params: PjBaseReq, unique: boolean = true): ng.IHttpPromise<{}> {

        // configを設定する
        let config: ng.IRequestShortcutConfig = {};
        config['unique'] = unique;
        config['screenId'] = url;

        // パラメータの組み立て
        let param: string = '',
            keys: string[] = Object.keys(params),
            length: number = keys.length;
        for (let i: number = 0; i < length; i++) {
            param = param + keys[i] + '=' + params[keys[i]] + '&';
        }

        // 末尾の&を削除する
        param = param.substring(0, param.length - 1);

        // GETでの通信処理
        return this.$http.get(url + '?' + param, config);
    }

    /**
     * サーバのデータを更新する
     * 送信の種類はPOST
     * @param {string} url url
     * @param {string} params リクエストパラメータ
     * @param {boolean} unique - 2重送信の抑止の設定(true：抑止, false：抑止しない）
     * @return {ng.IHttpPromise} 実行結果のプロミス
     */
    protected post(url: string, params: PjBaseReq, unique: boolean = true): ng.IHttpPromise<{}> {
        // configを設定する
        let config: ng.IRequestShortcutConfig = {};
        config['unique'] = unique;
        config['screenId'] = url;

        // POSTでの通信処理
        return this.$http.post(url, params, config);
    }

    /**
     * サービスの初期化時（アプリの起動時）にエラーが発生したときの通知を行う
     *
     */
    protected noticeStartupError(status: number): void {
        // クライアント側で読み込みを中断したときに表示しないように変更
        if (status !== -1) {
            alert('システムの起動時にエラーが発生しました。再読み込みしてください。再読み込み後も問題が解決しない場合は、管理者にお問い合わせください。');
        }
    }
}



/** WEBPACK FOOTER **
 ** node_modules/tslint-loader!./src/common/extends_fw/service/PjBaseService.ts
 **/